/**
 * WordPress dependencies
 */
import { SVG, Path, G } from "@wordpress/primitives";
import React from "react";

const library = (
    <SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <G
            fill="#FF4A17"
            stroke="#FF4A17"
            strokeMiterlimit="10"
            strokeWidth=".5"
        >
            <Path d="M2.893 16.508c-.288 0-.48-.192-.576-.384-1.342-3.74-.959-7.385 1.151-10.263 2.015-2.877 5.468-4.7 8.825-4.7h.096c.288 0 .575.288.575.672 0 .288-.288.575-.671.575-2.878 0-6.043 1.63-7.865 4.125-1.247 1.822-2.494 4.891-.96 9.112.096.288-.095.671-.383.767-.096.096-.096.096-.192.096zM12.293 22.839c-1.247 0-5.372-.288-8.25-3.837-.19-.288-.19-.671.097-.863.288-.192.671-.192.863.096 2.59 3.165 6.235 3.357 7.29 3.357 5.083 0 9.016-3.645 9.591-8.92 0-.384.384-.576.672-.576.384 0 .575.384.575.671-.575 5.947-5.083 10.072-10.838 10.072z" />
            <Path d="M1.454 17.85a.733.733 0 01-.48-.19c-.191-.289-.191-.672 0-.864l12.47-11.318c.192-.192.48-.192.767-.096.192.096.384.383.288.671l-1.918 7.961 6.81-8.44c.288-.288.671-.384.863-.192.288.096.384.383.384.671l-2.398 9.208 3.932-3.07c.288-.191.672-.191.864.097.191.288.191.671-.096.863l-5.372 4.125c-.192.191-.48.191-.767 0-.192-.192-.288-.384-.288-.672l2.206-8.057-6.81 8.345c-.192.192-.48.288-.767.192-.288-.096-.384-.384-.288-.672l2.11-8.632-11.03 9.88c-.192.095-.288.19-.48.19z" />
        </G>
    </SVG>
);

export default library;
